import { render, staticRenderFns } from "./TransferenciaLocFormComponent.vue?vue&type=template&id=61d57427&"
import script from "./TransferenciaLocFormComponent.vue?vue&type=script&lang=js&"
export * from "./TransferenciaLocFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports